import { E as t } from "./abstract-base-CdeHT0x1.js";
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const p = (r) => r != null ? r : t;
export {
  p as o
};
